import RequiredSign from "@components/common/ui-elements/required-sign";
import ButtonGroup from "@components/common/form-controls/button-group";
import {TERMS_AGREEMENT_CHOICE_OPTIONS} from "@constants/dropdown-choices";
import {isDetailsMode, useFormMode} from "@contexts/FormModeContext";

export const TermsAgreementBlock = ({
   labelText = 'Terms agreement',
   required = true,
   selectedValue = '',
   controlName = 'termsAgreement',
   controlIdPrefix = 'termsAgreement-',
   onChange,
   isHidden = false,
   descriptionText = `By clicking submit, you agree your explicit consent for us to use the data
            provided in accordance with the Data Protection act 2018, this data will be used to provide the
            cheapest possible quote while being shared with both offline and online markets.`
}) => {
   
   const {mode} = useFormMode();
   
   if(isDetailsMode(mode)) {
      return null;
   }
   
   if(isHidden) {
      return null;
   }
   
   return (
      <div className="col mb-3">
         <label className="form-label">
            {labelText} <RequiredSign
            required={required} />
         </label>
         
         <div>
            <ButtonGroup
               selectedValue={selectedValue}
               idPrefix={controlIdPrefix}
               name={controlName}
               options={TERMS_AGREEMENT_CHOICE_OPTIONS}
               onChange={onChange}
               required={required}
            />
         </div>
         
         <div className="form-text">{descriptionText}</div>
      
      </div>
   )
}